module.exports = __webpack_public_path__ + "static/img/certificado-9001-2015.2a8b2d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sistema-de-gestion-en/certificado-9001-2015.jpg
// module id = bePC
// module chunks = 0